import React, { useEffect } from 'react';
import { useSvgStore } from '../../store/svgStore';
import AISvgChatPanel from '../ai/AISvgChatPanel';
import SvgCanvasDesigner from '../canvas/SvgCanvasDesigner';
import PropertiesPanel from '../inspector/PropertiesPanel';
import '../../styles/ai-svg.css';

const AISvgLayout: React.FC = () => {
  const initNewCanvas = useSvgStore((state) => state.initNewCanvas);
  const loadAssets = useSvgStore((state) => state.loadAssets);
  const loadAiHistories = useSvgStore((state) => state.loadAiHistories);

  useEffect(() => {
    initNewCanvas();
    void loadAssets();
    void loadAiHistories();
  }, [initNewCanvas, loadAssets, loadAiHistories]);

  return (
    <div className="ai-svg-root-light">
      <div className="ai-svg-shell-light">
        <AISvgChatPanel />
        <SvgCanvasDesigner />
        <PropertiesPanel />
      </div>
    </div>
  );
};

export default AISvgLayout;